import api from "@/network";
import {AxiosResponse} from "axios";



type UpdateDto = {
    uuids: string[],
    status: boolean,
}

type GetAllDto = {
    page: number,
    per_page: number,
    settings: object,
}

type SetMassStatusDto = {
    status: string,
    sessions: string[],
}

type MassDeleteDto = {
    sessions: string[],
}
type MassRestoreDto = {
    sessions: string[],
}

type ExportSessionsDto = {
    page: number,
    per_page: number,
    settings: object,
}

export default {
    async getAll(params: GetAllDto): Promise<AxiosResponse> {
        return await api.get(`sessions`, {
            params: {
                page: params.page,
                per_page: params.per_page,
                settings: params.settings,
            }
        });
    },
    async update(dto: UpdateDto): Promise<AxiosResponse> {
        return await api.put(`sessions`, dto);
    },
    async setMassStatus(dto: SetMassStatusDto): Promise<AxiosResponse> {
        return await api.put(`sessions/status`, dto);
    },
    async massDelete(dto: MassDeleteDto): Promise<AxiosResponse> {
        // console.log(dto);
        return await api.delete(`sessions`, {
            params: dto
        });
    },
    async massRestore(dto: MassRestoreDto): Promise<AxiosResponse> {
        console.log(dto);
        return await api.post(`sessions/restore`, dto);
    },
    async export(dto: ExportSessionsDto): Promise<AxiosResponse> {
        return await api.get(`export/sessions`, {
            responseType: 'blob',
            params: dto,
        });
    },
    async import(file: File) {
        let formData = new FormData()
        formData.append('file', file);
        return await api.put('import/session', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
}
